import { NotificationManager, SiteConfigManager } from '@apollo/core';
import { appEvents } from '../constants';
import ToastManager, { formatToastMessage } from '../ToastManager';

/*
  Bus Events Mapping:
    - Binding actions with bus events
    - Resource loading handler
    - Logging events

    - Binding history with bus too
*/
export default (Bus) => {
  /*
    Check if bus already got listeners
  */
  if (Bus.listenerCount('newListener') > 0) {
    return;
  }

  Bus.on(Bus.events.auth.login, (profile) => {
    // Reload data so that any UI restrictions are applied
    SiteConfigManager.resolveCmsConfig().then();
    Bus.emit(Bus.events.profile.bonusReload);
    Bus.emit(Bus.events.profile.bundleReload);
    Bus.emit(Bus.events.sport.sportReInit);
    Bus.emit(Bus.events.racing.racingReInit);
  });

  Bus.on(Bus.events.auth.logout, () => {
    // This is done in Core Lib
    // AccountManager.logout();
  });

  Bus.on(appEvents.deviceResume, () => {
    SiteConfigManager.resolveCmsConfig();
  });

  Bus.on(appEvents.deviceNetworkOnline, () => {
    SiteConfigManager.resolveCmsConfig();
    Bus.emit(Bus.events.profile.bonusReload);
    Bus.emit(Bus.events.profile.bundleReload);
    Bus.emit(Bus.events.sport.sportReInit);
    Bus.emit(Bus.events.racing.racingReInit);
    Bus.emit(Bus.events.bespokeMarket.update);
  });

  Bus.on(appEvents.devicePause, () => {
    localStorage.setItem('devicePauseTime', JSON.stringify(Date.now()));
  });

  Bus.on(appEvents.deviceResume, ({ timeNow, devicePauseTime }) => {
    localStorage.removeItem('devicePauseTime');
  });

  Bus.on(Bus.events.notification.showFlashMessage, (data) => {
    const props = JSON.parse(data.data);
    const messageContent = formatToastMessage(props.body);
    ToastManager.showNotification(props.status, messageContent);
  });

  Bus.on(Bus.events.notification.showModalWindow, (data) => {
    const props = JSON.parse(data.data);
    NotificationManager.display({
      id: 'templatePopup',
      type: 'templatePopup',
      data: { htmlContent: props.body },
      status: props.status,
    });
  });

  Bus.on(Bus.events.profile.realityCheck, () => {
    NotificationManager.display({
      id: 'realityCheck',
      type: 'realityCheck',
      status: 'popup',
      title: 'reality_check_popup_title',
      message: 'reality_check_popup_message',
    });
  });

  Bus.on('cashout:success', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'success',
      title: 'cashout_success_title',
      message: 'cashout_success_message',
      data,
    });
  });

  Bus.on('partial_cashout:success', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'success',
      title: 'partial_cashout_success_title',
      message: 'partial_cashout_success_message',
      data,
    });
  });

  Bus.on('order_cashout:success', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'success',
      title: 'order_cashout_success_title',
      message: 'order_cashout_success_message',
      data,
    });
  });

  Bus.on('cashout:error', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'error',
      title: 'cashout_error_title',
      message: 'cashout_error_message',
      data,
    });
  });

  Bus.on('partial_cashout:wrong_amount', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'error',
      title: 'partial_cashout_wrong_amount_title',
      message: 'partial_cashout_wrong_amount_message',
      data,
    });
  });

  Bus.on('partial_cashout:error', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'error',
      title: 'partial_cashout_error_title',
      message: 'partial_cashout_error_message',
      data,
    });
  });

  Bus.on('order_cashout:error', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'error',
      title: 'order_cashout_error_title',
      message: 'order_cashout_error_message',
      data,
    });
  });

  Bus.on('order_partial_cashout:success', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'success',
      title: 'order_partial_cashout_success_title',
      message: 'order_partial_cashout_success_message',
      data,
    });
  });

  Bus.on('order_partial_cashout:error', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'error',
      title: 'order_partial_cashout_error_title',
      message: 'order_partial_cashout_error_message',
      data,
    });
  });

  Bus.on('cashout_not_allowed', (data) => {
    NotificationManager.display({
      type: 'notification',
      status: 'error',
      title: 'cashout_not_allowed_title',
      message: 'cashout_not_allowed_message',
      data,
    });
  });
};
